import { useState, useCallback } from 'react';

export function useCardCompanyScroll() {
  const [isContentScrollable, setIsContentScrollable] = useState(true);

  // Utilidad para obtener ancho del contenedor según tamaño
  const getContainerWidth = useCallback((size) => {
    switch (size) {
      case "Phone":
        return 362.4;
      case "Tablet":
        return 626;
      case "Desktop 1200":
        return 1057;
      case "Desktop 1440":
      default:
        return 1210;
    }
  }, []);

  // Utilidad para formatear clases de tamaño
  const getSizeClass = useCallback((size) => {
    return size.toLowerCase().replace(" ", "");
  }, []);

  // Toggle para scroll del contenido
  const toggleContentScroll = useCallback((enabled) => {
    setIsContentScrollable(enabled);
  }, []);

  return {
    isContentScrollable,
    getContainerWidth,
    getSizeClass,
    toggleContentScroll
  };
}